import { getBrokerPartnerRefundSignupParagraphs } from "./brokerPartnerRefundSignupText";

/**
 * Canonical Refund Policy lists & article copy.
 * Imported by `RefundPolicy.jsx` and `signupLegalDocuments.js` (Sign-up modal).
 */
export const REFUND_ELIGIBLE = [
  "Trading account is with an AlphaSniper-designated broker partner, opened and maintained according to our official partner links and onboarding instructions.",
  "Request submitted within the first 30 days of the first subscription month.",
  "Lot size must remain at 0.01 for all new accounts during the 1st month.",
  "Verified starting balance is available (example: 200 USD).",
  "After the 1st month expires, final balance is below starting balance (example: 150 USD vs 200 USD).",
  "Account followed required AlphaSniper copy settings during the guarantee month.",
];

export const REFUND_NOT_ELIGIBLE = [
  "Accounts not opened and maintained through our designated broker partner programme when the offer requires a broker partner (see eligibility notice above).",
  "Requests submitted after the first 30-day guarantee month.",
  "Any month after the 1st month (the guarantee does not apply to following months).",
  "Core risk settings changed outside recommended parameters during the 1st month.",
  "Account history cannot be verified (missing statement/access data).",
  "Manual intervention outside the normal auto-copy workflow.",
];

export const REFUND_HOW_TO_REQUEST = [
  "Contact support through the official AlphaSniper support channel during the guarantee window.",
  "Provide account identifier, payment proof, subscription start date, and full month statement.",
  "We review starting balance, end-of-month balance, and copy-compliance logs.",
  "If approved, the refund is processed through the original payment method.",
];

export const REFUND_GUARANTEE_SCOPE_PARAGRAPHS = [
  "This guarantee applies to the 1st month only. Refund eligibility is based on a simple comparison: verified starting balance versus balance at the end of the first subscription month.",
  "For all new accounts, lot size is fixed at 0.01 during the 1st month. This is a required condition for guarantee eligibility.",
];

export const REFUND_EXAMPLE =
  "Example: if the client starts with 200 USD and ends the first month with 150 USD, the account qualifies for refund review under this policy.";

export const REFUND_OPEN_TRADES =
  "If the subscription expires while there are floating profit/loss positions still open, the client account continues to follow our strategy account for those already-open copied trades until our strategy account closes them. Final guarantee assessment is made after those inherited open trades are closed.";

export const REFUND_TRADING_RESULTS_DISCLAIMER =
  "Trading involves substantial risk. Past performance does not guarantee future results. This refund policy does not remove market risk and does not constitute financial advice.";

/** Flat strings for Sign-up legal modal (same source as Refund Policy page). */
export function getRefundSignupLegalBody() {
  return [
    "30-Day Guarantee Scope",
    ...REFUND_GUARANTEE_SCOPE_PARAGRAPHS,
    REFUND_EXAMPLE,
    ...getBrokerPartnerRefundSignupParagraphs(),
    "Eligible for refund",
    ...REFUND_ELIGIBLE.map((item) => `• ${item}`),
    "Non-refundable situations",
    ...REFUND_NOT_ELIGIBLE.map((item) => `• ${item}`),
    "Open trades at subscription expiry",
    REFUND_OPEN_TRADES,
    "How to request a refund",
    ...REFUND_HOW_TO_REQUEST.map((item, idx) => `${idx + 1}. ${item}`),
    "Trading results disclaimer",
    REFUND_TRADING_RESULTS_DISCLAIMER,
  ];
}
